import { useEffect } from 'react';

/**
 * Hook for locking body scroll when component is mounted
 * @param isLocked - whether scrolling should be locked
 */
export const useScrollLock = (isLocked: boolean) => {
  useEffect(() => {
    if (!isLocked) return;

    // Save current scroll position
    const scrollY = window.scrollY;
    const body = document.body;
    const html = document.documentElement;

    // Lock scrolling
    body.style.position = 'fixed';
    body.style.top = `-${scrollY}px`;
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    html.style.overflow = 'hidden';

    // Cleanup - restore scrolling
    return () => {
      body.style.position = '';
      body.style.top = '';
      body.style.width = '';
      body.style.overflow = '';
      html.style.overflow = '';

      // Restore scroll position
      window.scrollTo(0, scrollY);
    };
  }, [isLocked]);
};
